import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { isHttpUrl, isInternalPath } from '../../lib/safeHref';

/** Header/footer chrome link. External http(s) URLs open in a new tab. */
export function SiteNavAnchor({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: ReactNode;
}) {
  if (isHttpUrl(href)) {
    return (
      <a href={href} className={className} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  if (isInternalPath(href)) {
    return (
      <Link to={href} className={className}>
        {children}
      </Link>
    );
  }
  return <span className={className}>{children}</span>;
}
